import React from "react"

import "./layout-stack.css"
import { ZoomLens } from "../ZoomLens"

const LayoutStack = ({ data }) => {
    let imageFitClass = (data.galleryFitOption === null || data.galleryFitOption === 'Cover') ? ' fit--cover':' fit--contain'
    let stackColumnNumber = (data.stackColumnNumber === null || data.stackColumnNumber === undefined) ? '3':data.stackColumnNumber;

    return (
        <div className="variant-stack">
            {data.videoGallery && data.videoGallery.map((item, index)=> {
                const videoId = item.videoLink ? item.videoLink.match(/(?:\/|%2F)([A-Za-z0-9_-]{11})/)[1] : '';
                const youtubeEmbedLink = `https://www.youtube.com/embed/${videoId}`;
                return (
                    <div key={index} className={`image${imageFitClass} image-${stackColumnNumber}`} style={{ backgroundColor: data.colorPicker }}>
                        <iframe 
                        className="w-full h-full"
                        src={youtubeEmbedLink} 
                        title="We Are Savor Brands" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        allowFullScreen></iframe>
                    </div>
                )
            })}
            {data.gallery && data.gallery.map((item, index) => {
                let srcSet
                if(item.gatsbyImageData.images.sources[1] !== undefined) {
                srcSet = item.gatsbyImageData.images.sources[1].srcSet.split(' ');
                srcSet = srcSet[0]
                }
                return (
                <div key={index} className={`image${imageFitClass} image-${stackColumnNumber}`} style={{ backgroundColor: data.colorPicker }}>
                    <ZoomLens imgUrl={item.gatsbyImageData.images.sources[1] !== undefined ? srcSet: item.gatsbyImageData.images.fallback.src} />
                </div>
            )})}
        </div>
    )
}

export default LayoutStack